import { useEffect } from 'react';
import { create } from 'zustand';

interface PageTitleState {
  /** Titulek nasazený stránkou — přebíjí statický klíč z `PAGE_TITLE_KEYS`. */
  title: string | null;
  setTitle: (title: string | null) => void;
}

export const usePageTitleStore = create<PageTitleState>(set => ({
  title: null,
  setTitle: title => set({ title }),
}));

/**
 * Nastaví titulek tabu pro stránku, která ho zná až za běhu — jméno produktu, číslo
 * objednávky, název zákazníka. Dokud je `title` prázdný, platí statický titulek z registru.
 *
 * Při odchodu ze stránky se přepis ruší; React spustí cleanup odcházející stránky dřív než
 * efekt té nové, takže se titulky nepřeperou.
 */
export const usePageTitle = (title?: string | null) => {
  const setTitle = usePageTitleStore(s => s.setTitle);

  useEffect(() => {
    if (!title) return;

    setTitle(title);
    return () => setTitle(null);
  }, [title, setTitle]);
};
